import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * Check the overall duration to determine if it is within the specified parameters
 * @param maximum
 * @param minimum
 */
export function durationValidator(maximum: number, minimum: number): ValidatorFn {
    return (abstractControl: AbstractControl): ValidationErrors | null => {
        if (abstractControl.value < minimum) {
            if (Math.floor(minimum / (3600 * 24))) {
                return {duration: `The duration is less than ${Math.floor(minimum / (3600 * 24))} days`};
            } else if (Math.floor(minimum % (3600 * 24) / 3600)) {
                return {duration: `The duration is less than ${Math.floor(minimum % (3600 * 24) / 3600)} hours`};
            } else {
                return {duration: `The duration is less than ${Math.floor(minimum / 60)} minutes`};
            }
        } else if (abstractControl.value > maximum) {
            if (Math.floor(maximum / (3600 * 24))) {
                return {duration: `The duration is more than ${Math.floor(maximum / (3600 * 24))} days`};
            } else if (Math.floor(maximum % (3600 * 24) / 3600)) {
                return {duration: `The duration is more than ${Math.floor(maximum % (3600 * 24) / 3600)} hours`};
            } else {
                return {duration: `The duration is more than ${Math.floor(maximum / 60)} minutes`};
            }

        } else {
            return null;
        }
    };
}
